/**
 * @fileoverview DELETE handler for the "/:app_group_id/operator_mcp_connections/:connection_id/tokens" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteAppGroupIdOperatorMcpConnectionsConnectionIdTokensCacheKeys } from "./constants";
import type {
  DeleteAppGroupIdOperatorMcpConnectionsConnectionIdTokensProps,
  DeleteAppGroupIdOperatorMcpConnectionsConnectionIdTokensResult,
} from "./types";

export const deleteAppGroupIdOperatorMcpConnectionsConnectionIdTokens = reactQueryMutationAdapter(
  deleteAppGroupIdOperatorMcpConnectionsConnectionIdTokensCacheKeys,
  ({
    appGroupId,
    connectionId,
  }: DeleteAppGroupIdOperatorMcpConnectionsConnectionIdTokensProps): Promise<DeleteAppGroupIdOperatorMcpConnectionsConnectionIdTokensResult> => {
    return fetch(`/${appGroupId}/operator_mcp_connections/${connectionId}/tokens`, "DELETE", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
